module.exports = __webpack_public_path__ + "8351a65d3e2b67bbc6f0cde0b3369209.svg";